import { BillingInfo, IBillingInfo } from "./billingInfo";
import { IOrderProductItem, OrderProductItem } from "./orderProductItem";
import { IOrderShipping, OrderShipping } from "./orderShipping";
import { IPayment, Payment } from "./payment";

export enum ShippingType {
    DELIVERY = "DELIVERY",
    PICKUP = "PICKUP",
}

export enum ShippingMode {
    REGULAR = "REGULAR",
    EXPRESS = "EXPRESS",
    NATIONWIDE = "NATIONWIDE",
}

export enum PreOrderType {
    RELATIVE = "PREORDER_RELATIVE",
    FIXED = "PREORDER_FIXED",
}

export enum OrderError {
    SHIPPING_TYPE_ERROR = "Please choose shipping type",
    DELIVERY_MODE_ERROR = "Please choose delivery mode",
    NO_PRODUCT = "No product in your order",
    SCHEDULE_DATE_TIME_ERROR = "Please choose time slot",
}

export interface IOrder {
    orderId?: string;
    ownerId?: string;
    basketId?: string;
    branchId?: string;
    couponCodeList?: string[];
    voucherId?: string[];
    specialComment?: string;
    requestSubstitute?: boolean;
    noPlasticBag?: boolean;
    productList?: IOrderProductItem[];
    shipping?: IOrderShipping;
    subTotal?: number;
    grandTotal?: number;
    bogoDiscount?: number;
    cartDiscount?: number;
    voucherDiscount?: number;
    billingInfo?: IBillingInfo;
    deliveryFee?: number;
    totalDiscount?: number;
    expressShippingCost?: number;
    promotionCode?: string;
    saleId?: string;
    payment?: IPayment;
    orderSource?: string;
}

export class Order implements IOrder {
    orderId?: string | undefined;
    ownerId?: string | undefined;
    basketId?: string | undefined;
    branchId?: string | undefined;
    couponCodeList: string[] = [];
    voucherId: string[] = [];
    specialComment = "";
    requestSubstitute = false;
    noPlasticBag = false;
    productList: IOrderProductItem[] = [];
    shipping?: IOrderShipping | undefined;
    subTotal?: number | undefined;
    grandTotal?: number | undefined;
    bogoDiscount?: number | undefined;
    cartDiscount?: number | undefined;
    voucherDiscount?: number | undefined;
    billingInfo?: IBillingInfo;
    deliveryFee?: number;
    totalDiscount?: number;
    expressShippingCost?: number;
    promotionCode?: string | undefined;
    saleId?: string | undefined;
    payment?: IPayment | undefined;
    orderSource?: string | undefined;

    constructor(data: IOrder) {
        this.orderId = data.orderId;
        this.ownerId = data.ownerId;
        this.basketId = data.basketId;
        this.branchId = data.branchId;
        this.couponCodeList = data.couponCodeList?.map((x) => x) || [];
        this.voucherId = data.voucherId?.map((x) => x) || [];
        this.specialComment = data.specialComment ? data.specialComment : "";
        this.requestSubstitute = data.requestSubstitute
            ? data.requestSubstitute
            : false;
        this.noPlasticBag = data.noPlasticBag ? data.noPlasticBag : false;
        this.productList =
            data.productList?.map((x) => new OrderProductItem(x)) || [];
        if (data.shipping) {
            this.shipping = new OrderShipping(data.shipping);
        }
        this.subTotal = data.subTotal;
        this.grandTotal = data.grandTotal;
        this.bogoDiscount = data.bogoDiscount;
        this.cartDiscount = data.cartDiscount;
        this.voucherDiscount = data.voucherDiscount;
        if (data.billingInfo) {
            this.billingInfo = new BillingInfo(data.billingInfo);
        }
        this.deliveryFee = data.deliveryFee;
        this.totalDiscount = data.totalDiscount;
        this.promotionCode = data.promotionCode;
        this.expressShippingCost = data.expressShippingCost;
        this.saleId = data.saleId;

        if (data.payment) {
            this.payment = new Payment(data.payment);
        }
        this.orderSource = data.orderSource;
    }

    data(): IOrder {
        const o = Object.assign({}, this);
        if (o.shipping) {
            if(o.shipping.scheduleList){
                for (let index = 0; index < o.shipping.scheduleList.length; index++) {
                    const sch = o.shipping!.scheduleList[index];
                    delete sch.productList;
                }
            }
        }

        return o;
    }
}
